import { useParams } from 'react-router-dom';
import Order from './Order';

export default function OrderWrapper() {
  const { id } = useParams();
  return <Order event_id={Number(id)} />;
}
